<template>
  <TableCell ref="tableCell" :tag="tag" v-model:showingPopover="showingPopover">
    {{ cellText }}
    <template #PopoverContentDesktop>
      <Button :disabled="pendingPushTest" @click="pushTest()">
        {{ pendingPushTest ? "Recording ..." : "Push test" }}
      </Button>
    </template>
  </TableCell>
</template>

<script setup>
import { computed, ref } from "vue";
import { promiseTimeout } from "@vueuse/core";
import TableCell from "./TableCell.vue";

let props = defineProps([
  "tag",
  "showingPopover"
]);

let showingPopover = defineModel("showingPopover");

let cellText = computed(() => {
  let connected = props.tag.value;
  let system = props.tag.$session.system;
  if (connected)
    return "Connected";
  else
    return "Not connected";
});

let tableCell = ref();
let pendingPushTest = ref(false);

function pushTest() {
  pendingPushTest.value = true;
  tableCell.value.repositionPopover();
  props.tag.$session.queueRequest("/cmd/pushTest", null, async () => {
    await promiseTimeout(500);
    showingPopover.value = false;
    pendingPushTest.value = false;
  });
}
</script>